// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__+pTZ5","icon":"Toast_icon__9rxE5","message":"Toast_message__jVoBJ","error":"Toast_error__V1WLu","info":"Toast_info__lq1iw","success":"Toast_success__QaE83"};